<template>
  <v-btn
    fab
    absolute
    top
    right
    v-if="
          ($store.state.storeAuth.userProfile.isSuperAdmin &&
            $store.state.storeAuth.userProfile.client ==
              $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin
        "
    small
    outlined
    color="primary"
    style="margin-top: 35px"
    :to="path"
  >
    <v-icon medium color="primary">mdi-pencil</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "home-menu-edit-card-btn",
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>